import ID from './ID'

export default class RelatedInitiativeMapping {
  constructor(
    public tacticId: ID = new ID(),
    public initiativeId: ID = new ID(),
    public initiativeTitle: string = '',
    public initiativeTypeId: ID = new ID(),
    public initiativeTypeName: string = '',

    public initiativeIdForCustomization: ID = new ID(), // For front-end use only - when initiativeTypeId is used for an InitiativeCustomization (when a new mapping is being created), this propery sotres the customization's parent Initiative ID
  ) {}

  public get key() {
    return 'related-initiative-mapping-' + this.tacticId.intID.toString() + '-' + this.initiativeId.intID.toString()
  }

  public static fromResponseObject(tacticIntId, initiativeObj): RelatedInitiativeMapping {
    if (!tacticIntId || !initiativeObj) return new RelatedInitiativeMapping()
    return new RelatedInitiativeMapping(
      ID.fromResponseObject(tacticIntId, 'tactics'),
      ID.fromResponseObject(initiativeObj.id, 'initiatives'),
      initiativeObj.title,
      ID.fromResponseObject(initiativeObj.initiativeType.id, 'initiative_types'), 
      initiativeObj.initiativeType.name
    )
  }

  public forRequestObject() {
    return this.initiativeIdForCustomization.intID !== 0 ? this.initiativeIdForCustomization.apiID : this.initiativeId.apiID 
  }
}
